import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ReimbursementformService } from '../../../Model/Reimbursement/reimbursementform.service';

@Component({
  selector: 'app-reimbursement-approval-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent],
  templateUrl: './reimbursement-approval-detail.component.html',
  styleUrl: './reimbursement-approval-detail.component.scss'
})
export class ReimbursementApprovalDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterID: null,
    ShiftTitle: null,
    // CompOffRequestDate: null,
    // LeaveFromDate: null,
    // LeaveToDate: null,
    // HalfDay: null,
    // HalfDaySession: null,
    // NoOfDays: null,
    Remark: null,
    RequestDate: null as any,
    MonthYear: null,
    ESS_ReimbursementTypeID: null,
    ReimbursementType: null,
    OutstandingAmount: null,
    ClaimedAmount: null,
    BillAmount: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
    Attachment: null
  };
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  Filter = {
    ModuleMasterId: 16,
    WebESSApprovalRequestTrackingId: 0,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private reimbursement: ReimbursementformService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.GetID = 2
    }
  }

  ngOnInit(): void {
    //this.DetailData.EmpType = this.user.EmpType,
    // console.log(this.DetailData.EmpType)
    console.log(this.GetID);
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      this.ESS_GetUserRole();
    } else if (this.GetID == 2) {
      this.ESS_ReimbursementLoad();
    }

    this.Filter.EmpMasterId = this.user.UserId;
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 16) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {

        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
          this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }).catch(() => { });
    } else {
      this.Filter.isShowError = true;
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  ESS_ReimbursementLoad() {
    this.DetailData.EmpType = this.user.EmpType,
      this.Filter.EmpMasterId = this.user.UserId;
    this.isDisabled = true
    this.reimbursement.ESS_ReimbursementRequest_Load({ ESS_ReimbursementRequestId: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterID: this.user.UserId, FromDate: null, ToDate: null, ApprovalStatus: "ALL", SelectType: 1 }).subscribe({
      next: (data) => {
        if (this.Filter.ModuleMasterId == 16) {
          if (data.Table.length > 0) {
            this.DetailData = data.Table[0];
          } else if (data.Table1.length > 0) {
            this.DetailData = data.Table1[0];
          } else if (data.Table2.length > 0) {
            this.DetailData = data.Table2[0];
          } else if (data.Table3.length > 0) {
            this.DetailData = data.Table3[0];
          }
        }
        else {
          this.isDisabled = false
        }
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }
  // ESS_EmployeeCompOffConsumeLoad() {
  //   this.isDisabled = true;
  //   this.compensatoryoff.ESS_EmployeeCompOffConsumeLoad({ ESS_EmployeeCompOffConsumeId: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterID: this.user.UserId, FromDate: null, ToDate: null, ApprovalStatus: "ALL", SelectType: 4 }
  //   ).subscribe({
  //     next: (response) => {
  //       console.log(response);
  //       this.DetailData.WebESSApprovalRequestTrackingId = 0,
  //         this.DetailData.TransactionId = response.Table1[0].TransactionId,
  //         this.DetailData.EmpMasterId = response.Table1[0].EmpMasterID,
  //         this.DetailData.EmpCode = response.Table1[0].EmpCode,
  //         this.DetailData.Photo = response.Table1[0].Photo,
  //         this.DetailData.EmployeeName = response.Table1[0].EmployeeName,
  //         // this.DetailData.BranchName = response.Table[0].BranchName,
  //         // this.DetailData.ClientLocation = response.Table[0].ClientLocation,
  //         // this.DetailData.DesignationMasterId = response.Table[0].DesignationMasterID,
  //         // this.DetailData.DesignationName = response.Table[0].DesignationName,
  //         // this.DetailData.ShiftMasterID = response.Table[0].DesignationName,
  //         // this.DetailData.ShiftTitle = response.Table[0].ShiftTitle,
  //         // this.DetailData.CompOffRequestDate = response.Table[0].CompOffRequestDate,
  //         // this.DetailData.LeaveFromDate = response.Table[0].LeaveFromDate,
  //         // this.DetailData.LeaveToDate = response.Table[0].LeaveToDate,
  //         // this.DetailData.HalfDay = response.Table[0].HalfDay,
  //         // this.DetailData.HalfDaySession = response.Table[0].HalfDaySession,
  //         // this.DetailData.NoOfDays = response.Table[0].NoOfDay,
  //         // this.DetailData.Reason = response.Table[0].Reason,
  //         this.DetailData.RequestDate = response.Table1[0].RequestDate,
  //         this.DetailData.MonthYear = response.Table1[0].MonthYear,
  //         this.DetailData.ESS_ReimbursementTypeID =  response.Table1[0].ESS_ReimbursementTypeID,
  //         this.DetailData.ReimbursementType = response.Table1[0].ReimbursementType,
  //         this.DetailData.OutstandingAmount = response.Table1[0].OutstandingAmount,
  //         this.DetailData.ClaimedAmount =  response.Table1[0].ClaimedAmount,
  //         this.DetailData.BillAmount =  response.Table1[0].BillAmount,
  //         this.DetailData.EmpType = this.user.EmpType,
  //         this.DetailData.ApprovalStatus = response.Table1[0].ApprovalStatus,
  //         this.DetailData.Attachment =  response.Table1[0].Attachment
  //         this.isDisabled = false;
  //       console.log(this.DetailData.ApprovalStatus)
  //     },
  //     complete: () => {
  //       this.ApprovalMatrixRequestGetTracking();
  //     },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'Reimbursement' + '/' + Text;
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/reimbursementapproval/']);
      }
      else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/reimbursement/approval/']);
      }
    }
    else if (this.GetID == 2) {
      this.router.navigate(['/request/reimbursement/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
